import { useState } from 'react';

import { CustomTooltip } from 'common-ui/table/CustomTooltip';
import Pagination from 'common-ui/table/Pagination';

import {
  CardBody,
  CardContent,
  CardGroupWrapper,
  CardHeader,
  CardItem,
  CardLabel,
  CompetitorCardItem,
  EmptyData,
  InfoCard,
  Key,
  PaginationWrapper,
  Span,
  Value,
} from './Components.styles';

export const Card = ({
  action,
  data,
  title,
  additional,
  setShowCompetitorInfo,
  pagination = false,
}) => {
  const [currentPage, setCurrentPage] = useState(0);
  let visibleIndex = 0;
  const truncateText = (text, maxLength = 40) => {
    if (text.length > 40) {
      return (
        <CustomTooltip title={text}>
          <Span>{text.slice(0, maxLength) + '...'}</Span>
        </CustomTooltip>
      );
    }
    return text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
  };

  const handlePageChange = (page) => {
    setCurrentPage(page - 1);
    data[pagination ? page - 1 : 0].onClick();
  };
  return (
    <InfoCard>
      <CardHeader>
        <CardLabel>{title}</CardLabel>
        {action}
      </CardHeader>
      <CardContent>
        <CardBody>
          {Array.isArray(data) && data.length > 0 ? (
            <CardGroupWrapper>
              {data[pagination ? currentPage : 0].group.map((elm, i) => {
                if (!elm?.value) return null;
                const isBlueText =
                  elm.label === 'Company' ||
                  elm.label === 'Full name' ||
                  elm.label === 'Offer name' ||
                  elm.label === 'Name';
                const bgColor = visibleIndex % 2 === 0 ? '#ECF1FB' : undefined;
                visibleIndex++;

                const isDualField = elm.label === 'DualField';
                const isCenterField = elm.label === 'CenterField';
                const isStackField = elm.label === 'StackField';

                return (
                  <CardItem
                    key={i}
                    $color={bgColor}
                    $isDualField={isDualField}
                    $isCenterField={isCenterField}
                    $isStackField={isStackField}
                  >
                    {isDualField ? (
                      <>
                        {elm.value && typeof elm.value === 'string'
                          ? elm.value.includes(' Price: ')
                            ? elm.value.split(' Price: ').map((part, index) => (
                                <Key key={index} $isDualField={true}>
                                  {index === 0 ? part : `Price: ${part}`}
                                </Key>
                              ))
                            : elm.value.split(' End Date: ').map((part, index) => (
                                <Key key={index} $isDualField={true}>
                                  {index === 0 ? part : `End Date: ${part}`}
                                </Key>
                              ))
                          : null}
                      </>
                    ) : isCenterField ? (
                      <Key $isCenterField={true}>{elm.value}</Key>
                    ) : isStackField ? (
                      <>
                        <Key $isStackField={true}>{elm.stackLabel}</Key>
                        <Value $isStackField={true}>{elm.value}</Value>
                      </>
                    ) : (
                      <>
                        <Key>{elm.label}</Key>
                        <Value $textColor={isBlueText ? '#2D6CDF' : undefined}>
                          {typeof elm.value === 'string' && elm.value.includes('<') ? (
                            <Span dangerouslySetInnerHTML={{ __html: elm.value }} />
                          ) : (
                            truncateText(elm.value)
                          )}
                        </Value>
                      </>
                    )}
                  </CardItem>
                );
              })}
            </CardGroupWrapper>
          ) : (
            <EmptyData>
              <Key>No data available</Key>
            </EmptyData>
          )}
        </CardBody>

        {pagination && data.length > 1 && (
          <PaginationWrapper>
            <Pagination
              currentPage={currentPage + 1}
              totalPages={data.length}
              onPageChange={handlePageChange}
            />
          </PaginationWrapper>
        )}

        {additional && (
          <CompetitorCardItem>
            <Key>Competitor info</Key>
            <Value $underline={true} onClick={() => setShowCompetitorInfo()}>
              View
            </Value>
          </CompetitorCardItem>
        )}
      </CardContent>
    </InfoCard>
  );
};
